var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.file.url,"alt":_vm.file.name,"loading":"lazy"},on:{"load":function($event){_vm.loaded = true}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a032262","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/File.vue
// module id = 53
// module chunks = 0